<template
    v-if="categoriesStore.topLevelCategories"
    v-for="category in categoriesStore.topLevelCategories"
>
    <div
        v-if="category.isQuickFilter"
        class="js-quick-filter shrink-0 basis-[100px] leading-none  flex-col
        items-center text-center h-full"
    >
        <input
            type="checkbox"
            v-bind:id="category.id"
            class="js-top-level-category peer sr-only"
            v-bind:value="category.id"
            v-bind:checked="parseInt(categoriesStore.chosenTopLevelCategory) === parseInt(category.id)"
            v-on:click="topLevelCategoryClick"
        >
        <label
            v-bind:for="category.id"
            v-bind:title="category.title"
            class="relative group text-xs cursor-pointer peer-checked:font-bold mb-0
            peer-focus-visible:ring-4 leading-tight
            peer-focus-visible:ring-primary-light/80
            peer-checked:text-primary
            peer-checked:before:block
            peer-checked:before:absolute
            peer-checked:before:w-[50px]
            peer-checked:before:h-[50px]
            peer-checked:before:top-0
            peer-checked:before:left-[calc(50%-25px)]
            peer-checked:before:rounded-[50%]
            peer-checked:before:bg-primary-lightest
            peer-checked:before:z-[-1]"
        >
            <IconRenderer :svg="category.filterIconSvg" v-if="category.filterIconSvg" />
            <img
                class="w-[30px] h-[30px] mx-auto mb-qtr"
                v-else
                src="../../assets/no-image-1x1.png"
                loading="lazy"
                alt=""
            />
            <span class="text-ellipsis max-w-6 truncate block mt-qtr group-hover:font-bold text-gray-600">{{category.title}}</span>
        </label>
    </div>
</template>
